import { LANGUAGE_CODES } from 'locales/constants';
import theme from 'shell/themes';

export const AVATAR_COLOR_OPTIONS = Object.freeze([
    {
        bgColor: theme.palette.ensightful.error[800],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.error[600],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.error[100],
        textColor: theme.palette.ensightful.error[900],
    },

    {
        bgColor: theme.palette.ensightful.success[700],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.success[400],
        textColor: theme.palette.ensightful.success[900],
    },
    {
        bgColor: theme.palette.ensightful.success[100],
        textColor: theme.palette.ensightful.success[900],
    },

    {
        bgColor: theme.palette.ensightful.warning[800],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.warning[500],
        textColor: theme.palette.ensightful.neutral[900],
    },
    {
        bgColor: theme.palette.ensightful.warning[100],
        textColor: theme.palette.ensightful.warning[900],
    },

    {
        bgColor: theme.palette.ensightful.secondary[800],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.secondary[400],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.secondary[100],
        textColor: theme.palette.ensightful.secondary[900],
    },

    {
        bgColor: theme.palette.ensightful.primary[800],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.primary[500],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.primary[100],
        textColor: theme.palette.ensightful.primary[900],
    },

    {
        bgColor: theme.palette.ensightful.neutral[800],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.neutral[500],
        textColor: theme.palette.ensightful.neutral[900],
    },
    {
        bgColor: theme.palette.ensightful.neutral[200],
        textColor: theme.palette.ensightful.neutral[900],
    },
]);

const CITATION_FORMATS = Object.freeze([
    { key: 'mla', value: 'MLA (9th Edition)' },
    { key: 'apa', value: 'APA (7th Edition)' },
]);

export const CITATION_SELECT_OPTIONS = Object.freeze([{ key: 'none', value: 'Default (None)' }, ...CITATION_FORMATS]);

export const RUBRIC_OPTION_DESCRIPTION_WORD_COUNT_LIMIT = 600;

export const CUSTOM_CONTENT_WORD_COUNT_LIMIT = 1000;

export const CUSTOM_INSTRUCTIONS_WORD_COUNT_LIMIT = 4000;

export const DESCRIPTION_WORD_COUNT_LIMIT = 7000;

export const FEEDBACK_LIMIT = 3;

export const AI_REGENERATE_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? process.env.REACT_APP_AWS_REGION === 'ca-central-1'
            ? 'https://f2bnjondnqisqrvrmqb75stjp40axihr.lambda-url.ca-central-1.on.aws/'
            : 'https://cac32upk2uid5sjezg27xqfxmu0gxswy.lambda-url.us-east-1.on.aws/'
        : 'https://2zoe4h3rtx3p2h4u6kzkqeboqq0hehkj.lambda-url.us-east-1.on.aws/';

export const AI_FEEDBACKS_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? process.env.REACT_APP_AWS_REGION === 'ca-central-1'
            ? 'https://ynhdxwzkjmbyoy5t72gdzz7jta0ghgan.lambda-url.ca-central-1.on.aws/'
            : 'https://cjfseerku2kn2fr5f7fx47xoqu0tbkbk.lambda-url.us-east-1.on.aws/'
        : 'https://mdpewo3pcwghxmleg3rmxssrpm0achbk.lambda-url.us-east-1.on.aws/';

export const AI_GRADE_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? process.env.REACT_APP_AWS_REGION === 'ca-central-1'
            ? 'https://6ztdme4sflktfxesb445sdm2ua0ovskj.lambda-url.ca-central-1.on.aws/'
            : 'https://ra5p7bk6rig4ccnksdnwa2ztpm0oruxe.lambda-url.us-east-1.on.aws/'
        : 'https://z33horgw3yx2dhev6nljia4p7q0ejveo.lambda-url.us-east-1.on.aws/';

export const AI_RUBRICS_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? 'https://oihpcwgcxs4e7slcabvfa3m7mi0rblpm.lambda-url.us-east-1.on.aws/'
        : 'https://5vtpzaspykcf5x3zmpjxds4pii0gkrms.lambda-url.us-east-1.on.aws/';

export const AI_BATCH_CANCEL_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? 'https://2o7c7awogm3opolm5gvaiopx2q0iragt.lambda-url.us-east-1.on.aws/'
        : 'https://c45q2i6hfpy555xubnznatoao40yyxaw.lambda-url.us-east-1.on.aws/';

export const SECTION_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? 'https://rihyqsqbd2tqmxzsbewiq7aq3u0rfljg.lambda-url.us-east-1.on.aws/'
        : 'https://rjqpuulewmaejsgojgwixyyt2i0wjmeh.lambda-url.us-east-1.on.aws/';

export const AI_RUBRIC_MODIFICATION_URL = 'https://sylohx4kybp4x6bzvhwig7kele0uejol.lambda-url.us-east-1.on.aws/';

export const DEFAULT_FEEDBACK_STRUCTURE = 'rubric';

export const DEFAULT_FEEDBACK_NUM_SUGGESTIONS = '3';

export const DEFAULT_FEEDBACK_SUGGESTION_LENGTH = '25-50';

export const DEFAULT_FEEDBACK_LANGUAGE_LEVEL = 'undergraduate';

export const DEFAULT_FEEDBACK_TONE = 'balanced';

export const DEFAULT_INLINE_COMMENTS_MAX_COMMENTS_PER_PAGE = '2';

export const DEFAULT_INLINE_COMMENTS_COMMENT_LENGTH = '25-50';

export const DEFAULT_INLINE_COMMENTS_LANGUAGE_LEVEL = 'undergraduate';

export const DEFAULT_INLINE_COMMENTS_TONE = 'balanced';

export const EXAMPLE_ASSIGNMENT_ID = 'example_assignment_id';

export const EXAMPLE_SUBMISSION_ID = 'example_submission_id';

export const CONTENT_BANK_RESOURCES_MB_LIMIT = 200;

export const PREVIEW_SUBMISSIONS_LIMIT = 3;

export const DurationFormat = Object.freeze({
    MIN_SEC: 'mm:ss',
    HOUR_MIN: 'hh:mm',
});

export const SortOrder = Object.freeze({
    ASC: 'asc',
    DESC: 'desc',
});

export const FilterOption = Object.freeze({
    ALL: 'all',
});

export const Placeholder = Object.freeze({
    NO_DATA: '--',
});

export const SubmissionTabs = Object.freeze({
    SUBMISSIONS: 'submissions',
    GRADING_INSIGHTS: 'grading-insights',
});

export const LanguageList = [
    { label: 'English', value: LANGUAGE_CODES.EN },
    { label: 'Español', value: LANGUAGE_CODES.ES },
];

export const FileTypes = Object.freeze({
    PDF: 'pdf',
    DOCUMENT: 'document',
    SHEET: 'sheet',
    PRESENTATION: 'presentation',
    VIDEO: 'video',
});

export const CourseImportType = Object.freeze({
    NAME: 'name',
    ID: 'id',
});

export const SUBMISSION_ALLOWED_FILE_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/csv',
    'video/*',
];

export const CONTENT_BANK_ALLOWED_FILE_TYPES = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/csv',
];
